import { httpClient } from "@/services/http/client";

export async function createCheckout(input: {
  courseId: string;
  currency: "INR" | "USD";
  couponCode?: string;
  referralCode?: string;
}): Promise<{ redirectUrl: string }> {
  const res = await httpClient.post<{ data: { redirectUrl: string } }>(
    "/v1/checkout/create",
    input,
  );
  return res.data.data;
}

export async function validateCheckoutCoupon(input: {
  courseId: string;
  currency: "INR" | "USD";
  code: string;
}): Promise<{ finalAmount: number }> {
  const res = await httpClient.post<{ data: { finalAmount: number } }>(
    "/v1/checkout/validate-coupon",
    input,
  );
  return res.data.data;
}
